import type { SessionView } from '@wodi/shared';

import { can } from '../api/session.ts';
import type { DocumentPermissions } from './documents-panel.tsx';

/** What the signed-in person may do with clinical documents (the server checks again). */
export function documentPermissions(session: SessionView | null): DocumentPermissions {
  const has = (p: Parameters<typeof can>[1]) => session !== null && can(session, p);
  return {
    readIssued: has('clinical.read'),
    issueSickSheet: has('sick_sheets.issue'),
    writeReferral: has('referrals.write'),
    readDocuments: has('documents.read'),
    uploadDocuments: has('documents.upload'),
  };
}
